<template>
    <div>
        <div class="text-center" v-if="loader">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <v-row>
                <v-col cols="12" sm="12">
                    <v-card>
                        <v-container fluid>
                            <v-row v-viewer class="images" v-if="cards.length > 0">
                                <v-col v-for="image in images" :key="image" class="d-flex child-flex" cols="3">
                                    <v-card flat tile class="d-flex">
                                        <img :src="image" :lazy-src="image" aspect-ratio="1" class="grey image"
                                            @click="show">
                                        <!-- <template v-slot:placeholder>
                                <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                                >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                            </template> -->
                                        <!-- </v-img> -->
                                    </v-card>
                                </v-col>
                            </v-row>
                            <div v-else>
                                <p>Pas de cartes générées pour l'instant</p>
                            </div>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>

            <div class="text-xs-center pt-2">
                <v-pagination v-model="currentPage" :length="cardPagination.last_page" total-visible="16">
                </v-pagination>
            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
    name: "card-view",
    data() {
        return {
            url: window.config.appUrl,
            loader: false,
            search: '',
            payload: {
                query: {
                    page: 1,
                    size: 16
                }
            },
            footerProps: {
                "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
                "items-per-page-text": "Lignes par page",
            },
        }
    },
    created() {
            this.fetchCard()
    },
    computed: {
        images() {
            let data = []
            this.cards.forEach(card => {
                let lien = this.url + '/' + card.card
                data.push(lien)
            });
            return data;
        },
        rowsPerPageItems: {
            get: function () {
                return this.$store.getters.rowsPerPageItems;
            },

            set: function (value) {
                this.payload.query.size = value;
                this.fetchCard();
            },
        },
        currentPage: {
            get: function () {
                return this.$store.getters.cardPagination.current_page
            },

            set: function (value) {
                this.payload.query.page=value
                this.fetchCard();
            },
        },
        cardPagination() {
            return this.$store.getters.cardPagination;
        },
        cardTotalItems() {
            return this.$store.getters.cardTotalItems;
        },
        ...mapGetters([
            'cards'
        ])
    },
    methods: {
        show() {
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
        },
        async fetchCard() {
            this.loader = true
            this.currentPage
            await this.$store.dispatch('fetchCards', this.payload)
            this.loader = false
        }

    }
}
</script>
<style scoped>
.image {
    height: 200px;
    width: 210px;
    cursor: pointer;
    margin: 5px;
    display: flex;
    flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/actors/card.vue